import {
  REJECT_TIMECARD,
  REJECT_TIMECARD_LOADING,
  REJECT_TIMECARD_FAIL,
  APPROVE_TIMECARD,
  APPROVE_TIMECARD_LOADING,
  APPROVE_TIMECARD_FAIL,
  APPROVE_ALL_TIMECARDS,
  APPROVE_ALL_TIMECARDS_LOADING,
  APPROVE_ALL_TIMECARDS_FAIL,
  REJECT_VALIDATION,
  REJECT_VALIDATION_LOADING,
  REJECT_VALIDATION_FAIL,
  GET_EMPLOYEE_DETAILS,
  GET_EMPLOYEE_DETAILS_START,
  GET_EMPLOYEE_DETAILS_FAIL,
  APPROVE_ALL_WITHOUT_EMAIL_LOADING,
  APPROVE_ALL_WITHOUT_EMAIL,
  APPROVE_ALL_WITHOUT_EMAIL_FAIL
} from "./actionTypes";
import { instance } from "../utilities/services";
import moment from 'moment';
import { fetchTimecardWeeks } from './fetchAssignmentAndTimeCardDetails';

export const postApproveAllTimecards = (data, callback) => async dispatch => {
  try {
    dispatch({ type: APPROVE_ALL_TIMECARDS_LOADING });
    const response = await instance.post("Timecard/approveAllTimecards", data);
    dispatch({
      type: APPROVE_ALL_TIMECARDS,
      timecardsStatus: response.data
    });
    callback(response);
  } catch (error) {
    console.log(error);
    dispatch({ type: APPROVE_ALL_TIMECARDS_FAIL, error });
    callback(false);
  }
};

export const postApproveAllTimecardsWithoutEmail = (data, callback) => async dispatch => {
  try {
    dispatch({ type: APPROVE_ALL_WITHOUT_EMAIL_LOADING });
    const response = await instance.post("Timecard/approveAllTimecardsWithoutConfirmation", data);
    dispatch({
      type: APPROVE_ALL_WITHOUT_EMAIL,
      timecardsStatus: response.data
    });
    callback(response);
  } catch (error) {
    console.log(error);
    dispatch({ type: APPROVE_ALL_WITHOUT_EMAIL_FAIL, error });
    callback(false);
  }
};

export const postApproveTimecard = (data, callback) => async (dispatch, getState) => {
  try {
    dispatch({ type: APPROVE_TIMECARD_LOADING });
    const response = await instance.post("Timecard/timecardApprove", data);
    let input = getState().filterData.filterData;
    dispatch(fetchEmployeeDetails(input));
    dispatch({
      type: APPROVE_TIMECARD,
      timecard: response.data.TimecardApprovedResponse
    });
    callback(response);
  } catch (error) {
    dispatch({ type: APPROVE_TIMECARD_FAIL, error });
    // callback(false);
  }
};

export const postRejectionTimecard = (data, callback) => async (dispatch, getState) => {
  try {
    dispatch({ type: REJECT_TIMECARD_LOADING });
    const response = await instance.post("Timecard/timecardRejection", data);
    let input = getState().filterData.filterData;
    dispatch(fetchEmployeeDetails(input));
    dispatch({
      type: REJECT_TIMECARD,
      timecard: response.data.TimecardRejectionResponse
    });
    callback(response);
  } catch (error) {
    console.log(error);
    dispatch({ type: REJECT_TIMECARD_FAIL, error });
    callback(false);
  }
};

export const postRejectionValidation = (data,callback) => async dispatch => {
  try {
    dispatch({ type: REJECT_VALIDATION_LOADING });
    const response = await instance.post(
      "Timecard/timecardRejectionValidation",
      data
    );
    dispatch({
      type: REJECT_VALIDATION,
      timecard: response.data.TimecardRejectionResponse
    });
    callback(response)
  } catch (error) {
    console.log(error);
    dispatch({ type: REJECT_VALIDATION_FAIL, error });
  }
};

// Api call for fetching admin homepage data or the filter data
export const fetchEmployeeDetails = (data, type) => async dispatch => {
  try {
    dispatch({ type: GET_EMPLOYEE_DETAILS_START });
    const response = await instance.post("Timecard/clientHome", data);
    // if(type==="showmore"){
    //     if(!response.data.AdminHomeView.length > 0){
    //         return dispatch({type: NO_MORE_RECORDS});
    //     }else{
    //         dispatch({type: SHOW_MORE_EMPLOYEE_DETAILS,employeeDetails:response.data});
    //     }
    // }else{
    //     dispatch({type: GET_EMPLOYEE_DETAILS,employeeDetails:response.data})
    //     dispatch({type: LOADER_END})
    // }

    // if(response){
    //   return true
    // } else{
    //   return false
    // }
  console.log(response.data);
    //Remove pending timecards older than 1 month, update length to match
    response.data.ClientHome = response.data.ClientHome.filter((record) => moment(record.timecardWeekEndDate).isBetween(moment(new Date()).subtract(1, 'month'), moment(new Date())));
    response.data.RecordCount = response.data.ClientHome.length;
    console.log('after filter:')
    console.log(response.data)
    //

    dispatch({ type: GET_EMPLOYEE_DETAILS, employeeDetails: response });
  } catch (error) {
    console.log(error);
    dispatch({ type: GET_EMPLOYEE_DETAILS_FAIL, error });
  }
};
